import { useNavigate } from 'react-router-dom';
import bulletpoints from '../../assets/dashboard/bulletpoints.png';
import calendario from '../../assets/dashboard/calendario.png';
import checklist from '../../assets/dashboard/checklist.png';
import contactos from '../../assets/dashboard/contactos.png';
import etiqueta from '../../assets/dashboard/etiqueta.png';
import grafico from '../../assets/dashboard/grafico.png';
import peso from '../../assets/dashboard/peso.png';
import portafolio from '../../assets/dashboard/portafolio.png';
import settings from '../../assets/dashboard/settings.png';
import usuario from '../../assets/dashboard/usuario.png';
import home from '../../assets/dashboard/home.png';
import mouBordes from '../../assets/mouBordes.png';

const Sidebar = () => {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate('/personas/dashboard');
  };

  const handleAccountClick = () => {
    navigate('/personas/dashboard/mi-cuenta');
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleAccountClick();
    }
  };

  const handleHomeKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleHomeClick();
    }
  };

  return (
    <div className="absolute top-0 left-0 h-full bg-[#032c65] z-50 group transition-all duration-300 w-16 hover:w-64 flex flex-col items-center group-hover:items-start py-28 gap-8 overflow-hidden pl-5 group-hover:pl-24 pr-4">
      <img src={mouBordes} alt="Logo" className="w-48 mb-4 hidden group-hover:block" />
      <div
        className="flex items-center gap-4 w-full cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70"
        onClick={handleHomeClick}
        onKeyDown={handleHomeKeyDown}
        tabIndex={0}
        role="button"
      >
        <img src={home} alt="Inicio" className="w-6" />
        <span className="text-white font-bold hidden group-hover:inline text-left">Inicio</span>
      </div>
      <div className="flex items-center gap-4 w-full">
        <img src={bulletpoints} alt="Inicio" className="w-6" />
        <span className="text-white font-bold hidden group-hover:inline text-left">Bulletpoints</span>
      </div>
      <div className="flex items-center gap-4 w-full">
        <img src={calendario} alt="Calendario" className="w-6" />
        <span className="text-white font-bold hidden group-hover:inline text-left">Calendario</span>
      </div>
      <div className="flex items-center gap-4 w-full">
        <img src={etiqueta} alt="Etiqueta" className="w-6" />
        <span className="text-white font-bold hidden group-hover:inline text-left">Etiqueta</span>
      </div>
      <div className="flex items-center gap-4 w-full">
        <img src={checklist} alt="Checklist" className="w-6" />
        <span className="text-white font-bold hidden group-hover:inline text-left">Checklist</span>
      </div>
      <div className="flex items-center gap-4 w-full">
        <img src={peso} alt="Peso" className="w-6" />
        <span className="text-white font-bold hidden group-hover:inline text-left">Peso</span>
      </div>
      <div
        className="flex items-center gap-4 w-full cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70"
        onClick={handleAccountClick}
        onKeyDown={handleKeyDown}
        tabIndex={0}
        role="button"
      >
        <img src={usuario} alt="Mi cuenta" className="w-6" />
        <span className="text-white font-bold hidden group-hover:inline text-left">Mi cuenta</span>
      </div>
      <div className="flex items-center gap-4 w-full">
        <img src={contactos} alt="Contactos" className="w-6" />
        <span className="text-white font-bold hidden group-hover:inline text-left">Contactos</span>
      </div>
      <div className="flex items-center gap-4 w-full">
        <img src={portafolio} alt="Portafolio" className="w-6" />
        <span className="text-white font-bold hidden group-hover:inline text-left">Portafolio</span>
      </div>
      <div className="flex items-center gap-4 w-full">
        <img src={settings} alt="Settings" className="w-6" />
        <span className="text-white font-bold hidden group-hover:inline text-left">Settings</span>
      </div>
      <div className="flex items-center gap-4 w-full">
        <img src={grafico} alt="Gráfico" className="w-6" />
        <span className="text-white font-bold hidden group-hover:inline text-left">Gráfico</span>
      </div>
    </div>
  );
};

export default Sidebar;
